itsoftApp.createModule("filters", ['windowResize'], function () {
    const module = this;
    window.viewWidth = itsoftApp.commonVars.viewWidth ? itsoftApp.commonVars.viewWidth : itsoftApp.utils.getViewportSize();
    window.mobileWidth = 1023;
    window.defaultItemsCount = 12;
    window.mobileItemsCount = 6;

    itsoftApp.modules.windowResize.addEvent(function () {
      viewWidth = itsoftApp.utils.getViewportSize();
    });
 
    const init = function (filtersSection, cb) {
        const filtersForm = filtersSection.querySelector(".js-filters");
        const filtersBlocks = filtersSection.querySelectorAll(".js-filter-block");

        const initFilterBlock = function (filterBlock) {
            const filtersItems = filterBlock.querySelectorAll(".js-filter-item");
            const filtersAllItem = filterBlock.querySelector(".js-filter-item--all");
            const filtersItemsWithoutAll = filterBlock.querySelectorAll(".js-filter-item:not(.js-filter-item--all)");
            const filtersLabels = filterBlock.querySelectorAll(".js-filter-label");
            const resetButton = filterBlock.querySelector(".js-reset-button");

            const changeFilter = function () {
              const checkedFilters = Array.prototype.filter.call(filtersItemsWithoutAll, item => item.checked);

              if (filtersAllItem) {
                if (checkedFilters.length > 0) {
                  filtersAllItem.disabled = false;
                  filtersAllItem.removeAttribute("checked");
                  filtersAllItem.checked = false;
                } else {
                  filtersAllItem.disabled = true;
                  filtersAllItem.checked = true;
                }
              }
            }

            const isAllButton = function (filterItem) {
              return filterItem.classList.contains("js-filter-item--all") ? true : false;
            }

            const resetFilters = function () {
              if (filtersAllItem) {
                filtersAllItem.checked = true;
                filtersAllItem.disabled = true;
              }

              Array.prototype.forEach.call(filtersItemsWithoutAll, function (item) {
                item.checked = false;
              });

              createRequest();
            }

            const createRequest = function () {
              let allFiltersValues = [];

              allFiltersValues = Array.prototype.map.call(filtersBlocks, function (filterBlock) {
                const allFiltersItems = filterBlock.querySelectorAll(".js-filter-item") || [];
                const allCheckedFilters = Array.prototype.filter.call(allFiltersItems, item => item.checked) || [];
                
                return {
                  name: filterBlock.getAttribute("name") || filterBlock.getAttribute("data-name") || allCheckedFilters[0].name,
                  value: Array.prototype.map.call(allCheckedFilters, (checkedFilter) => checkedFilter.value)
                }
              });

              debouncer(allFiltersValues);
            }

            const entityMap = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;',
                '/': '&#x2F;',
                '`': '&#x60;',
                '=': '&#x3D;'
            };

            const escapeHtml = function (string) {
                return String(string).replace(/[&<>"'`=\/]/g, function (s) {
                    return entityMap[s];
                });
            }

            const sendRequest = function (allFiltersValues) {  
              let url = "?";
  
              Array.prototype.forEach.call(allFiltersValues, function (filterValue, index, arr) {
                const selectName = filterValue.name;
                const selectValue = filterValue.value.join(';');

                url += selectName + "=" + selectValue;

                if (index < arr.length - 1) {
                  url += '&';
                }
              });

              if (viewWidth > mobileWidth) {
                url += '&' + 'amount' + "=" + defaultItemsCount;
              } else {
                url += '&' + 'amount' + "=" + mobileItemsCount;
              }
  
              url.replace(/\s/g, '+');
  
              const action = filtersForm.getAttribute("action");
  
              const query = action + url;
  
              // history.pushState("", "", url);
  
              cb(null, query);
            }

            const debouncer = itsoftApp.utils.debouncer(sendRequest, 500);

            if (resetButton) {
              resetButton.addEventListener("click", resetFilters);
            }

            Array.prototype.forEach.call(filtersItems, function (filterItem, index) {
              filterItem.addEventListener("change", function (evt) {
                console.log("CHANGE RADIO")
                const target = evt.currentTarget;
                if (isAllButton(filterItem)) {
                  resetFilters();
                  return;
                }

                changeFilter(target);
                createRequest();
              });
            });

            /* --- */

            Array.prototype.forEach.call(filtersLabels, function (filtersLabel) {
                filtersLabel.addEventListener("keyup", function (evt) {
                    if (evt.keyCode !== 13) {
                        return;
                    }

                    const target = evt.currentTarget;
                    const filterItem = target.closest(".js-filter-wrapper").querySelector(".js-filter-item");

                    if (isAllButton(filterItem)) {
                      resetFilters();
                      return;
                    }

                    if (filterItem.checked) {
                      filterItem.removeAttribute("checked");
                      filterItem.checked = false
                    } else {
                      filterItem.checked = true;
                    }

                    changeFilter(filterItem);
                    createRequest();
                });
            });
        }

        Array.prototype.forEach.call(filtersBlocks, function (filterBlock) {
            initFilterBlock(filterBlock);
        });
     }

    module.init = init;
 });